import { styled } from '@linaria/react'
import phoneCredit from '../../assets/home-v3/phone_credit.webp'
import paymentPlatforms from '../../assets/home-v3/payment_platforms.webp'
import { useTranslation } from 'react-i18next'
import { useNavigate } from '@tanstack/router'
import { useModal } from '@ebay/nice-modal-react'
import LoginModal from '../common/log-in-modal'
import { useBoundStore } from '../../store/store'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import store from '../../assets/home-v3/store.webp'
import visa from '../../assets/home-v3/visa.webp'
import dollar from '../../assets/home-v3/dollar.webp'
import cards from '../../assets/home-v3/cards.webp'
import { CASINO_CATEGORIES } from '../../constants/casino'

const Container = styled.div`
  padding: 36px 24px;
  @media (min-width: 1200px) {
    flex-direction: row;
    max-width: 1400px;
    margin: 0 auto;
    padding: 56px 36px 56px 0;
    border-bottom: 1px solid var(--secondary-txt-20);
  }
`

const Phone = styled(LazyLoadImage)`
  width: 340px;
  aspect-ratio: 628 / 653;
  margin-bottom: -60px;
  @media (min-width: 1200px) {
    width: 480px;
    margin-bottom: -50px;
  }
`

const Title = styled.h3`
  font-family: 'Poppins';
  font-weight: 700;
  font-size: 30px;
  text-align: center;
  color: #009fda;
  text-transform: uppercase;
  margin-bottom: 6px;
  @media (min-width: 1200px) {
    font-size: 48px;
    margin-bottom: 16px;
  }
`

const Text = styled.p`
  font-family: 'Poppins';
  font-size: 16px;
  color: var(--secondary-txt);
  text-align: center;
  span {
    font-weight: 600;
  }
  @media (min-width: 1200px) {
    font-size: 18px;
  }
`

const Platforms = styled(LazyLoadImage)`
  width: 100%;
  margin-top: 16px;
  aspect-ratio: 2491 / 262;
  @media (min-width: 1200px) {
    margin-top: 32px;
  }
`

const Options = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-top: 12px;
  @media (min-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
    margin-top: 32px;
  }
`

const OptionItem = styled.div`
  padding: 10px 8px;
  border-radius: 10px;
  border: 2px solid #009fda;
  min-width: 0;
  div {
    width: 40px;
    height: 40px;
    margin-right: 12px;
    img {
      max-width: 40px;
      max-height: 40px;
    }
  }
  p {
    font-size: 12px;
    line-height: 14px;
    font-family: 'Poppins';
    font-weight: 600;
    color: #009fda;
  }
  @media (min-width: 1200px) {
    padding: 12px 16px;
    div {
      margin-right: 20px;
    }
    p {
      font-size: 16px;
      line-height: 18px;
    }
  }
`

const Btn = styled.button`
  padding: 12px 0;
  background-color: var(--primary-btn-bg);
  border-radius: 6px;
  width: 100%;
  text-align: center;
  border-radius: 6px;
  margin: 0 auto;
  display: block;
  p {
    font-size: 16px;
    color: var(--primary-btn-txt);
    text-transform: uppercase;
  }
  &.login {
    background-color: var(--highlight);
  }
`

const BtnContainer = styled.div`
  gap: 12px;
  margin-top: 36px;
  display: flex;
  justify-content: center;
  width: 100%;
  @media (min-width: 1200px) {
    display: none;
  }
`

const OPTIONS = [
  {
    label: 'Tienda de conveniencia',
    img: store,
    aspectRatio: '177 / 119',
  },
  {
    label: 'Crédito y Debito',
    img: visa,
    aspectRatio: '27 / 28',
  },
  {
    label: 'Transferencias',
    img: dollar,
    aspectRatio: '1',
  },
  {
    label: 'Tarjetas Prepago',
    img: cards,
    aspectRatio: '61 / 42',
  },
]

const Transactions = () => {
  const navigate = useNavigate()
  const login = useModal(LoginModal)
  const { t } = useTranslation()
  const username = useBoundStore(state => state.user.username)

  return (
    <Container className="v-flx-ctr">
      <Phone src={phoneCredit} alt="Phone" />
      <div>
        <Title>Retiros y depósitos</Title>
        <Text>
          Deposita y retira fácilmente tu dinero con las opciones que tenemos en
          nuestro cajero
        </Text>
        <Platforms src={paymentPlatforms} alt="Payment Platforms" />
        <Options>
          {OPTIONS.map(option => (
            <OptionItem className="flx-str-ctr" key={option.label}>
              <div className="flx-str-ctr">
                <img
                  src={option.img}
                  alt={option.label}
                  style={{ aspectRatio: option.aspectRatio }}
                />
              </div>
              <p>{option.label}</p>
            </OptionItem>
          ))}
        </Options>
      </div>
      <BtnContainer>
        {username ? (
          <Btn
            onClick={() =>
              navigate({
                to: '/casino/$category',
                params: { category: CASINO_CATEGORIES[0].label },
              })
            }>
            <p>JUGAR AHORA</p>
          </Btn>
        ) : (
          <>
            <Btn onClick={() => navigate({ to: '/register' })}>
              <p>{t('register')}</p>
            </Btn>
            <Btn className="login" onClick={() => login.show()}>
              <p>{t('login')}</p>
            </Btn>
          </>
        )}
      </BtnContainer>
    </Container>
  )
}

export default Transactions
